// Login 2-step verification (e-mailed code) + Free plan track quota + sign-up plan notes
const en = {
  "auth2fa.title": "Check your e-mail",
  "auth2fa.subtitle": "We sent a 6-digit sign-in code to {email}. Enter it below to continue.",
  "auth2fa.codeLabel": "6-digit verification code",
  "auth2fa.verify": "Verify and sign in",
  "auth2fa.noCode": "Didn't get the code?",
  "auth2fa.resend": "Send a new code",
  "auth2fa.resendIn": "Resend in {s}s",
  "auth2fa.resent": "A new code has been sent.",
  "auth2fa.invalid": "Invalid verification code.",
  "auth2fa.emailNotSent": "The e-mail service isn't configured on this server, so the code couldn't be e-mailed. Ask the administrator to check the server log or configure the e-mail service.",
  "plan.paid": "Paid",
  "plan.labelSignupNote": "Paid plan · upgrade after sign-up",
  "plan.freeSignupNote": "Every account starts on the Free plan (up to 5 tracks). You can upgrade to Artist or Label any time from the Subscription page.",
  "plan.freeTitle": "Free plan",
  "plan.usageCount": "{used}/{limit} tracks used",
  "plan.usageLeft": "You can still release {left} more track(s) on the Free plan.",
  "plan.usageFull": "You've reached the Free plan limit. Upgrade to keep releasing music.",
  "plan.usageOverflow": "This release has {n} track(s) but only {left} are left on your Free plan. Remove tracks or upgrade before submitting.",
  "plan.upgrade": "Upgrade",
  "subscription.featFree1": "Up to 5 tracks (lifetime)",
};

const tr = {
  "auth2fa.title": "E-postanı kontrol et",
  "auth2fa.subtitle": "{email} adresine 6 haneli bir giriş kodu gönderdik. Devam etmek için kodu aşağıya gir.",
  "auth2fa.codeLabel": "6 haneli doğrulama kodu",
  "auth2fa.verify": "Doğrula ve giriş yap",
  "auth2fa.noCode": "Kod gelmedi mi?",
  "auth2fa.resend": "Yeni kod gönder",
  "auth2fa.resendIn": "{s} sn sonra tekrar gönder",
  "auth2fa.resent": "Yeni kod gönderildi.",
  "auth2fa.invalid": "Doğrulama kodu hatalı.",
  "auth2fa.emailNotSent": "Bu sunucuda e-posta servisi yapılandırılmadığı için kod e-postayla gönderilemedi. Yöneticiden sunucu kaydını kontrol etmesini veya e-posta servisini yapılandırmasını iste.",
  "plan.paid": "Ücretli",
  "plan.labelSignupNote": "Ücretli plan · kayıttan sonra yükselt",
  "plan.freeSignupNote": "Her hesap Free planla başlar (en fazla 5 şarkı). Dilediğin zaman Abonelik sayfasından Artist veya Label planına geçebilirsin.",
  "plan.freeTitle": "Free plan",
  "plan.usageCount": "{used}/{limit} şarkı kullanıldı",
  "plan.usageLeft": "Free planda {left} şarkı daha yayınlayabilirsin.",
  "plan.usageFull": "Free plan limitine ulaştın. Müzik yayınlamaya devam etmek için planını yükselt.",
  "plan.usageOverflow": "Bu yayında {n} şarkı var ama Free planında yalnızca {left} şarkı hakkın kaldı. Göndermeden önce şarkı çıkar veya planını yükselt.",
  "plan.upgrade": "Yükselt",
  "subscription.featFree1": "En fazla 5 şarkı (ömür boyu)",
};

const es = {
  "auth2fa.title": "Revisa tu correo",
  "auth2fa.subtitle": "Enviamos un código de acceso de 6 dígitos a {email}. Introdúcelo abajo para continuar.",
  "auth2fa.codeLabel": "Código de verificación de 6 dígitos",
  "auth2fa.verify": "Verificar e iniciar sesión",
  "auth2fa.noCode": "¿No recibiste el código?",
  "auth2fa.resend": "Enviar un código nuevo",
  "auth2fa.resendIn": "Reenviar en {s} s",
  "auth2fa.resent": "Se ha enviado un código nuevo.",
  "auth2fa.invalid": "Código de verificación incorrecto.",
  "auth2fa.emailNotSent": "El servicio de correo no está configurado en este servidor, por lo que no se pudo enviar el código. Pide al administrador que revise el registro del servidor o configure el correo.",
  "plan.paid": "De pago",
  "plan.labelSignupNote": "Plan de pago · mejóralo tras registrarte",
  "plan.freeSignupNote": "Todas las cuentas empiezan con el plan Free (hasta 5 canciones). Puedes pasar a Artist o Label cuando quieras desde la página de Suscripción.",
  "plan.freeTitle": "Plan Free",
  "plan.usageCount": "{used}/{limit} canciones usadas",
  "plan.usageLeft": "Aún puedes publicar {left} canción(es) más con el plan Free.",
  "plan.usageFull": "Has alcanzado el límite del plan Free. Mejora tu plan para seguir publicando música.",
  "plan.usageOverflow": "Este lanzamiento tiene {n} canción(es) pero solo te quedan {left} en el plan Free. Quita canciones o mejora tu plan antes de enviarlo.",
  "plan.upgrade": "Mejorar",
  "subscription.featFree1": "Hasta 5 canciones (de por vida)",
};

export default { en, tr, es };
